export function headerEmpresa(empresa) {
  const agora = new Date();

  const data = agora.toLocaleDateString('pt-BR');
  const hora = agora.toLocaleTimeString('pt-BR');

  return [
    {
      columns: [
        {
          width: '*',
          stack: [
            { text: empresa.RAZAO_SOCIAL, bold: true, fontSize: 10 },
            { text: `CNPJ: ${empresa.CGC}`, fontSize: 8 },
            { text: empresa.ENDERECO, fontSize: 8 }
          ]
        },
        {
          width: 'auto',
          alignment: 'right',
          stack: [
            { text: `Data: ${data}`, fontSize: 8 },
            { text: `Hora: ${hora}`, fontSize: 8 }
          ]
        }
      ],
      margin: [15, 10, 15, 10]
    },
    {
      canvas: [
        { type: 'line', x1: 0, y1: 0, x2: 555, y2: 0, lineWidth: 1 }
      ],
      margin: [15, 0, 15, 10]
    }
  ];
}